import { useRouteMatch } from 'react-router';
import { get } from 'lodash';
import { BASE_FORM_ROUTE_PATH } from '../config/routes';
import { useMultiLayerPathParams } from '../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';

const EMPTY_OBJECT = {};
export const useEntityType = (entityPathMap = EMPTY_OBJECT) => {
    const routeMatch = useRouteMatch(BASE_FORM_ROUTE_PATH);
    const entityMatch = get(routeMatch, 'params.entity');
    const { entity: entityPath } = useMultiLayerPathParams();

    const entity = entityPath || entityMatch;

    return entityPathMap[entity] || entity;
};
